// src/composables/useDeviceDetect.js
// Lightweight device detection for the mobile sidecar. Routing keys off the
// user agent (a true phone), not viewport width — so resizing a desktop window
// never bounces anyone. A per-device "force desktop" override (set by the
// Switch to full site link) lets a phone user opt into the full CRM.

import { ref } from 'vue'

const FORCE_DESKTOP_KEY = 'gse_force_desktop'
// Phones only — tablets (incl. iPadOS reporting as Mac) intentionally get the
// full desktop CRM, which is built for their width.
const MOBILE_UA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|Silk/i

export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || navigator.vendor || ''
  return MOBILE_UA.test(ua)
}

export function isForceDesktop() {
  try {
    return sessionStorage.getItem(FORCE_DESKTOP_KEY) === '1'
  } catch {
    return false
  }
}

export function setForceDesktop(on) {
  // Session-scoped on purpose: every fresh mobile sign-in re-lands on the
  // sidecar; "Full site" only opts out for the current browser session.
  try {
    if (on) sessionStorage.setItem(FORCE_DESKTOP_KEY, '1')
    else sessionStorage.removeItem(FORCE_DESKTOP_KEY)
  } catch {
    /* ignore */
  }
}

// Should this signed-in session land on the mobile sidecar?
export function shouldUseMobileSidecar() {
  return isMobileDevice() && !isForceDesktop()
}

export function useDeviceDetect() {
  const isMobile = ref(isMobileDevice())
  const forceDesktop = ref(isForceDesktop())

  function enterFullSite() {
    setForceDesktop(true)
    forceDesktop.value = true
  }
  function returnToMobile() {
    setForceDesktop(false)
    forceDesktop.value = false
  }

  return { isMobile, forceDesktop, enterFullSite, returnToMobile }
}
